import React, { useCallback } from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useLocalization } from '@im/react-localization';

type Props = {
  dismissAllHandler?: () => void;
  onClickInsightsCenter?: () => void;
  showInsightsCenter?: boolean;
};

export default function InsightsFooter(props: Props) {
  const { translate } = useLocalization();
  const {
    dismissAllHandler,
    onClickInsightsCenter,
    showInsightsCenter = true,
  } = props;

  const onClickInsightsButton = useCallback(() => {
    if (onClickInsightsCenter) onClickInsightsCenter();
  }, [onClickInsightsCenter]);

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={1}>
      <StyledButton
        onClick={dismissAllHandler}
        size="medium"
        sx={{ display: 'none' }}
        variant="outlined"
      >
        Dismiss All
      </StyledButton>
      {showInsightsCenter && (
        <StyledButton
          onClick={onClickInsightsButton}
          size="medium"
          variant="contained"
        >
          {translate('Insights.InsightsCenter')}
        </StyledButton>
      )}
    </Stack>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
}));
